import { all, spawn, call } from 'redux-saga/effects';
import authSaga from './authSaga';
import userSaga from './userSaga';
import userServletSaga from './userServletSaga';
import othersSaga from './othersSaga';
import guidelineSaga from './guidelineSaga';
import { watchCreatorSaga } from '../creator/creatorModules';

export default function* rootSaga() {
  const sagas = [authSaga, userSaga, userServletSaga, othersSaga, guidelineSaga, watchCreatorSaga];

  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
        }
      })
    )
  );
}
